import { PcmpMisQueueTable } from '../components/PcmpMisQueue/PcmpMisQueueTable';

export function PcmpMisQueuePage() {
  return <PcmpMisQueueTable />;
}
